module.exports = __webpack_public_path__ + "static/media/location-pin.80284a6f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/icons/location-pin.png
// module id = 881
// module chunks = 0